

import axios from 'axios';
import moment from 'moment';
import { URL } from '../tools/ApiRoutes';

// URL Authentication Endpoint


/**
 * Iniciar sesión con microsoft
 * @return {any} promise
 */
const userInfo = (user) => {

    // const headers = {
    //     'Content-Type': 'application/json',
    // };

    return axios.get(`${URL}/usarios/usarioAccesos?Login=${user}`, {}, {})
        .then(({ data }) => {
            return data;
        });
};

export const UserService = {
    userInfo,
};